$(function(){
    $('.page-home-services .page-wrap').uniformify({
        selector: '> .content > .column > *'
    });
});